import {Box, Text} from "@mantine/core";
import cx from "clsx";
import commonClasses from "../../../../common/common.module.css"
import {DashboardIcons} from "../../common/constants";
import {IProtocolStats} from "../../types/IProtocolStats";
import {SessionRow} from "./SessionRow";

interface TimelinePanelProps {
    pStats: Array<IProtocolStats>
}

export const TimelinePanel: React.FC<TimelinePanelProps> = ({pStats}: TimelinePanelProps) => {

    return (
        <Box style={{display: "grid", grid: "auto 1fr / auto"}}>
            <Box mt={"1em"} mb={"1em"} style={{display: "grid", grid: "auto / 1fr", alignItems: "start"}}>
                <Box ml="0.5em" className={cx("ntc-row-component ntc-flex-align-center")}>
                    <DashboardIcons.durationIcon c={"black"}/>
                    <Text ml={"0.5em"} size={"1.5em"} fw={"bold"}>Session Timeline</Text>
                </Box>
                <Box className={cx(commonClasses.subtleText)}>Chronological view of all protocol sessions</Box>
            </Box>
            {pStats.map((stats) => (<SessionRow key={`tp-${stats.id}`} stats={stats} showSubject={true}/>))}
        </Box>
    )
}